var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconType.icon,{tag:"component",staticClass:"status__icon",class:_vm.iconType.class})}
var staticRenderFns = []

export { render, staticRenderFns }